export function getGuiBasedOnRowIndexAndColId(
  rowIndex: number,
  columnId: string
): HTMLElement | null {
  const root =
    document.querySelector('.cdk-overlay-container ag-grid-angular') ||
    document.querySelector('ag-grid-angular');

  return root?.querySelector(`div[row-index="${rowIndex}"]>[col-id="${columnId}"]`) || null;
}

export function isOverflowing(targetNode: Element | null): boolean {
  if (!targetNode) return false;
  const tolerance = 2;

  return (<HTMLElement>targetNode).offsetWidth + tolerance <= targetNode.scrollWidth;
}
